import { Phone, Mail, MapPin, MessageCircle, FileText } from "lucide-react";

export default function Contact() {
  return (
    <section id="contacto" className="py-20 bg-gradient-to-br from-blue-600 to-cyan-600 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold">Contáctanos</h2>
          <p className="text-blue-100 max-w-3xl mx-auto">
            Estamos listos para ayudarte con tu equipamiento médico
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">

          <ContactCard icon={Phone} title="Teléfono" lines={[
            "(506)-8335-4555",
          ]} />

          <ContactCard icon={Mail} title="Correo" lines={[
            "mgutierrez@serefimed.com",
          ]} />

          <ContactCard icon={MapPin} title="Dirección" lines={[
            "San Pablo de Heredia",
            "Heredia, Costa Rica",
          ]} />

        </div>

        <div className="mt-12 text-center flex flex-col sm:flex-row justify-center items-center gap-6">

          <a 
            href="https://wa.me/50683354555"
            target="_blank"
            className="bg-green-500 hover:bg-green-600 px-8 py-4 rounded-lg font-bold text-lg flex items-center space-x-3 shadow-lg"
          >
            <MessageCircle className="w-6 h-6" />
            <span>WhatsApp 24/7</span>
          </a>

          <a 
            href="#cotizacion"
            className="bg-white text-blue-600 hover:bg-blue-50 px-8 py-4 rounded-lg font-bold text-lg flex items-center space-x-3 shadow-lg"
          >
            <FileText className="w-6 h-6" />
            <span>Solicitar Cotización</span>
          </a>

        </div>

      </div>
    </section>
  );
}

function ContactCard({ icon: Icon, title, lines }) {
  return (
    <div className="text-center">
      <div className="w-16 h-16 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-4">
        <Icon className="w-8 h-8" />
      </div>
      <h3 className="text-xl font-bold mb-2">{title}</h3>
      {lines.map((l, i) => (
        <p key={i} className="text-blue-100">{l}</p>
      ))}
    </div>
  );
}
